export const getFamilyHistory = (familyHistory) => {
  const entries = familyHistory?.taskEntry;
  if (!entries) {
    return '';
  }


  if (entries?.doYouHaveAFamilyHistoryOfPkd.toLowerCase() === 'no') {
    return 'You do not have a family member with ADPKD';
  }

  const widthADPKDDiagnose = [];
  let childrenCount = 0;
  let auntsFromFatherSideCount = 0;
  let auntsFromMotherSideCount = 0;
  let unclesFromFatherSideCount = 0;
  let unclesFromMotherSideCount = 0;
  let grandMotherFromMotherSideCount = 0;
  let grandMotherFromFatherSideCount = 0;
  let grandFatherFromMotherSideCount = 0;
  let grandFatherFromFatherSideCount = 0;
  let nephewsCount = 0;
  let niecesCount = 0;
  let siblingsCount = 0;
  for (const key in entries) {
    const entry = entries[key];
    if (entry === 'diagnosedWithAdpkd') {
      if (key === 'motherAdpkdDiagnosis') {
        widthADPKDDiagnose.push('Mother');
      } else if (key === 'fatherAdpkdDiagnosis') {
        widthADPKDDiagnose.push('Father');
      } else if (key === 'grandmotherMothersSideAdpkdDiagnosis') {
        grandMotherFromMotherSideCount++;
      } else if (key === 'grandmotherFathersSideAdpkdDiagnosis') {
        grandMotherFromFatherSideCount++;
      } else if (key === 'grandfatherMothersSideAdpkdDiagnosis') {
        grandFatherFromMotherSideCount++;
      } else if (key === 'grandfatherFathersSideAdpkdDiagnosis') {
        grandFatherFromFatherSideCount++;
      } else if (key.toLowerCase().includes('child')) {
        childrenCount++;
      } else if (key.toLowerCase().includes('nephew')) {
        nephewsCount++;
      } else if (key.toLowerCase().includes('niece')) {
        niecesCount++;
      } else if (key.toLowerCase().includes('sibling')) {
        siblingsCount++;
      } else if (
        key.toLowerCase().includes('aunt') &&
        key.toLowerCase().includes('father')
      ) {
        auntsFromFatherSideCount++;
      } else if (
        key.toLowerCase().includes('aunt') &&
        key.toLowerCase().includes('mother')
      ) {
        auntsFromMotherSideCount++;
      } else if (
        key.toLowerCase().includes('uncle') &&
        key.toLowerCase().includes('father')
      ) {
        unclesFromFatherSideCount++;
      } else if (
        key.toLowerCase().includes('uncle') &&
        key.toLowerCase().includes('mother')
      ) {
        unclesFromMotherSideCount++;
      }
    }
  }
  // Children
  if (childrenCount > 0) {
    widthADPKDDiagnose.push(`Children(${childrenCount})`);
  }
  // Aunts
  if (auntsFromFatherSideCount > 0 && auntsFromMotherSideCount > 0) {
    widthADPKDDiagnose.push(
      `Aunts(${auntsFromFatherSideCount} from father side, ${auntsFromMotherSideCount} from mother side)`
    );
  }
  if (auntsFromFatherSideCount > 0 && auntsFromMotherSideCount === 0) {
    widthADPKDDiagnose.push(
      `Aunts(${auntsFromFatherSideCount} from father side)`
    );
  }
  if (auntsFromFatherSideCount === 0 && auntsFromMotherSideCount > 0) {
    widthADPKDDiagnose.push(
      `Aunts(${auntsFromFatherSideCount} from mother side)`
    );
  }
  // Uncles
  if (unclesFromFatherSideCount > 0 && unclesFromMotherSideCount > 0) {
    widthADPKDDiagnose.push(
      `Uncles(${unclesFromFatherSideCount} from father side, ${unclesFromMotherSideCount} from mother side)`
    );
  }
  if (unclesFromFatherSideCount > 0 && unclesFromMotherSideCount === 0) {
    widthADPKDDiagnose.push(
      `Uncles(${unclesFromFatherSideCount} from father side)`
    );
  }
  if (unclesFromFatherSideCount === 0 && unclesFromMotherSideCount > 0) {
    widthADPKDDiagnose.push(
      `Uncles(${unclesFromFatherSideCount} from mother side)`
    );
  }
  // Grandmother
  if (
    grandMotherFromFatherSideCount > 0 &&
    grandMotherFromMotherSideCount > 0
  ) {
    widthADPKDDiagnose.push('Grandmother(Father side, Mother side)');
  }
  if (
    grandMotherFromFatherSideCount > 0 &&
    grandMotherFromMotherSideCount === 0
  ) {
    widthADPKDDiagnose.push('Grandmother(Father side)');
  }
  if (
    grandMotherFromFatherSideCount === 0 &&
    grandMotherFromMotherSideCount > 0
  ) {
    widthADPKDDiagnose.push('Uncles(Mother side)');
  }
  // Grandfather
  if (
    grandFatherFromFatherSideCount > 0 &&
    grandFatherFromMotherSideCount > 0
  ) {
    widthADPKDDiagnose.push('Grandfather(Father side, Mother side)');
  }
  if (
    grandFatherFromFatherSideCount > 0 &&
    grandFatherFromMotherSideCount === 0
  ) {
    widthADPKDDiagnose.push('Grandfather(Father side)');
  }
  if (
    grandFatherFromFatherSideCount === 0 &&
    grandFatherFromMotherSideCount > 0
  ) {
    widthADPKDDiagnose.push('Uncles(Mother side)');
  }
  // Siblings
  if (siblingsCount > 0) {
    widthADPKDDiagnose.push(`Siblings(${siblingsCount})`);
  }
  // Nephews
  if (nephewsCount > 0) {
    widthADPKDDiagnose.push(`Nephews(${nephewsCount})`);
  }
  // Nieces
  if (niecesCount > 0) {
    widthADPKDDiagnose.push(`Nieces(${niecesCount})`);
  }
  return widthADPKDDiagnose.join(', ');
};
